<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 18 18">
    <g transform="translate(-364 -770)">
      <path
        d="M2.25,9.938H4.5L7.313,3.75l4.5,11.813,2.813-5.625h2.25"
        transform="translate(363.438 769.625)"
        fill="none"
        stroke="#495057"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
         :style="{ fill: 'none !important' }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconEye',

  props: {
    size: { type: [String, Number], default: '24px' },
  }
}
</script>